/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["@media (max-width:1627px) and (min-width:1200px){.pad-res[_ngcontent-%COMP%]{padding:0 100px 0 0!important}}.primary-background[_ngcontent-%COMP%]{background-color:var(--primary-color)!important;border-color:var(--primary-color)!important}"];
export { styles as styles };
